export default {"src":"/_next/static/media/diving.be042f4a.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};